import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken,
  setToken,
  setUserId,
  removeToken,
  removeRedirectUrl,
  removeUserId
} from '@/utils/auth' // getToken from cookie
import {Message} from 'element-ui'
import {APPID} from '../config/apiConfig'

NProgress.configure({showSpinner: false}) // NProgress Configuration

const warningList = ['Repair', 'Service', 'WarrantyEnquiry'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  // // 跳过鉴权
  // setToken('9ec83a02-25a4-4831-948e-dba394797840')
  // setUserId('401')
  // next()
  if (getToken()) {
    if (!store.getters.userName) {
      // 拉取用户信息
      store.dispatch('GetUserInfo').then(response => {
        const data = response.data
        if (data.code === '0') {
          store
            .dispatch('SetUserInfo', data.data)
            .then(() => {
              if (
                to.path.indexOf(warningList[0]) !== -1 ||
                                to.path.indexOf(warningList[1]) !== -1 ||
                                to.path.indexOf(warningList[2]) !== -1
              ) {
                if (
                  store.getters.authStatus === 1 &&
                                    store.getters.status === 0
                ) {
                  next()
                  NProgress.done()
                } else {
                  store.dispatch('SetRedirectUrl', to.path)
                  next('/PersonalInfo')
                }
              } else {
                // 不在危险链接名单
                next()
                NProgress.done()
              }
            })
            .catch(() => {
            })
        } else if (
          data.code === '20001' ||
                    data.code === '20005' ||
                    data.code === '20010' ||
                    data.code === '20015'
        ) {
          store.dispatch('SetRedirectUrl', to.path)
          removeToken()
          removeUserId()
          Message({
            message: data.message,
            type: 'error',
            duration: 3 * 1000
          })
          var jumpUrl =
                        window.location.protocol + '//' + window.location.host + to.path
          window.location.href =
                        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                        APPID +
                        '&redirect_uri=' +
                        jumpUrl +
                        '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        }
      })
    } else {
      next()
      NProgress.done()
    }
  } else {
    if (to.query.code !== undefined) {
      store.dispatch('WxGetToken', to.query.code).then(response => {
        next(store.getters.redirectUrl)
        removeRedirectUrl()
      })
    } else {
      store.dispatch('SetRedirectUrl', to.path)
      var jumpUrl =
                window.location.protocol + '//' + window.location.host + to.path
      window.location.href =
                'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                APPID +
                '&redirect_uri=' +
                jumpUrl +
                '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
    }
  }
})

router.afterEach(to => {
  window.document.title = to.meta.title
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js